import { createUseQuery } from 'api/common/createUseQuery'
import { fetchGroupUsersApi } from 'api/groups/fetchers/fetchGroupUsersApi'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useGroupUsersApi = createUseQuery({
  queryKey: ApiQueryKeys.GROUP_USERS,
  fetcher: fetchGroupUsersApi,
  selector: response => response?.data || [],
})
